import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface NewStudent {
  userId: string
  name: string
  nameKana: string
  birthday: string
  gender: SystemCode
  studentGrade: SystemCode
  studentClass: SystemCode
  studentNumber: string
}

export function NewStudentFromJSON(json: any): NewStudent {
  return {
    userId: exists(json, 'user_id') ? json.user_id : '',
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    birthday: exists(json, 'birthday') ? dateToPlainFormat(json.birthday) : '',
    gender: exists(json, 'gender')
      ? SystemCodeFromJSON(json.gender)
      : defaultSystemCode(),
    studentGrade: exists(json, 'student_grade')
      ? SystemCodeFromJSON(json.student_grade)
      : defaultSystemCode(),
    studentClass: exists(json, 'student_class')
      ? SystemCodeFromJSON(json.student_class)
      : defaultSystemCode(),
    studentNumber: exists(json, 'student_number') ? json.student_number : ''
  }
}
